import './styles/global.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import routes from './views/routes';
import App from './views/App.jsx';
import { dynamicActivate } from 'util/i18n.js';


// With this method we dynamically load the catalogs
dynamicActivate(navigator?.language?.split('-')[0]);

/*
 * This essentially just bootstraps our app and routing
 */

/**
 * @summary Initialize router.
 *
 * @name Router
 * @see {@link https://reactrouter.com/en/main/routers/create-browser-router|createBrowserRouter}
 *
 * @description Routes will be exposed by the view they represent and included
 * by the parent to avoid having a monolith.
 */
const router = createBrowserRouter([
  {
    path: '/',
    Component: App,
    // loader: () => {},
    children: [...routes],
  },
]);


/**
 * @summary Bootstrap the Thermon Egis Server Application
 *
 * @name Boostrap
 * @see {@link https://react.dev/reference/react-dom/client/createRoot|createRoot}
 *
 * @description An element with an id of "root" (`<div id="root"></div>`) is
 * expected to bootstrap the app.
 */
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router}></RouterProvider>
  </React.StrictMode>
)
